import showView from "../views/index";
import AppEvent from '../helpers/appEvent' 

const pdfSuscriptoSinPDF = () => {
    showView('pdf_suscripto_sin_acceso')
    //AppEvent.sendEvent('TIENE_DEUDA');
}

export default pdfSuscriptoSinPDF;


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/controllers/pdfSuscriptoSinPDF.js